import { chatIAState } from './ChatAiState';

export const useConversationList = () => {
  return chatIAState((state) => ({
    currentConversationId: state.currentConversationId,
    setCurrentConversationId: state.setCurrentConversationId,
    conversationList: state.conversationList,
    setConversation: state.setConversation,
    newConversationControl: state.newConversationControl,
    inputControlList: state.inputControlList,
    setInputControl: state.setInputControl,
  }));
};
